import React from "react";
import { assetImg } from "@/modules/moduleImporter";
import { ILongerGameStatisticsProps } from "@/types/LongerStatisticsTypes";
import { shioFightsAnimals, isPortrait } from "@/modules/commonMobile";
import { IShioFightsHistoryType } from "@/types/GameHistoryTypes";

import "./index.scss";
import { beadJSX, processMultilineStatistics } from "@/modules/statistics";

interface IProps extends Omit<ILongerGameStatisticsProps, "history"> {
	history: IShioFightsHistoryType[];
}

//Todo: Make this the new standard for multi line statistics
class IM27 extends React.Component<IProps> {
	statisticsArray = [];
	// animalCounts = {}; //{"rat": 0, "ox": 0, "tiger": 0, "rabbit": 0, "dragon": 0, "snake": 0, "horse": 0, "goat": 0, "monkey": 0, "rooster": 0, "dog": 0, "pig": 0};

	filtrate(history: IShioFightsHistoryType[]) {
		// console.log("props on m22 gs:", this.props);
		
		let tians = 0, dis = 0, ties = 0;
		//const wincontainer = [],
			//animalWinCount = {},

		//Fill animal "cages"
		const animalCounts = {};

		shioFightsAnimals.forEach(animal => {
			animalCounts[animal] = 0;
		});

		//Process Di/Tian/Tie
		for (const h of history) {// let i = 0; i < history.length; i++) {
			const item = h.win; // history[i].win;
			switch (item) {
				case "di":
					dis++;
				break;
				case "tian":
					tians++;
				break;
				case "tie":
					ties++;
				break;
				default: break;
			}
		}

		//Process Animals
		history.forEach(item => {
			if (item.win === "di")
				animalCounts[item.di]++;
			else animalCounts[item.tian]++;
		});

		//Static cells
		const statisticsCells = {
			top: [
				beadJSX("circle", "red", "D"),
				beadJSX("circle", "blue", "T"),
				beadJSX("circle", "green", "T"),

				...shioFightsAnimals.map(animal =>
					<div key={"m27_" + animal}>
						{assetImg("shio_fight_bottom", animal)}
					</div>
				)
			],

			bottom: [
				<div key={1} className="value">
					<span>
						{ dis }
					</span>
				</div>,
				<div key={2} className="value">
					<span>
						{ tians }
					</span>
				</div>,
				<div key={3} className="value">
					<span>
						{ ties }
					</span>
				</div>,

				...shioFightsAnimals.map(animal =>
					<div key={"m27_" + animal} className="value">
						<span>
							{Math.round(animalCounts[animal] / history.length * 100)}%
						</span>
					</div>
				)
			]
		};

		//Output
		const cellsPerLine = 5;
		this.statisticsArray = [];

		processMultilineStatistics(this.statisticsArray, statisticsCells, cellsPerLine, isPortrait(),
			"m27");

		/*
		if (isPortrait())
			for (let a = 0; a < Math.round(statisticsCells.top.length / cellsPerLine); a++)
				this.statisticsArray.push(...[
					//Top
					<tr key={"gs_m27_1_" + a}>
						{
							statisticsCells.top
								.slice(a * cellsPerLine, (a + 1) * cellsPerLine)
								.map((ele, eleIdx) =>
								<td key={"gs_m27_" + a + "_" + eleIdx}>
									{ele}
								</td>	
							)
						}
					</tr>,

					//Bottom
					<tr key={"gs_m27_2_" + a}>
						{
							statisticsCells.bottom
								.slice(a * cellsPerLine, (a + 1) * cellsPerLine)
								.map((ele, eleIdx) =>
								<td key={"gs_m27_" + a + "_" + eleIdx}>
									{ele}
								</td>	
							)
						}
					</tr>
				]);
		else this.statisticsArray.push(...[
			//Top
			<tr key={"gs_m27_1"}>
				{
					statisticsCells.top.map((ele, eleIdx) =>
					<td key={"gs_m27_1_" + eleIdx}>
						{ele}
					</td>
					)
				}
			</tr>,

			//Bottom
			<tr key={"gs_m27_2"}>
				{
					statisticsCells.bottom.map((ele, eleIdx) =>
					<td key={"gs_m27_2_" + eleIdx}>
						{ele}
					</td>
					)
				}
			</tr>
		]);
		*/
	}

	render() {
		if (!this.props.history)
			return null;

		this.filtrate(this.props.history);

		const statisticsTable = (
			<table><tbody>
				{ this.statisticsArray }
			</tbody></table>
		);
		
		return (
			<div className={"game-statistics m27" +
					(isPortrait() ? " multiline" : "") +
					(this.props.baccaratDarkMode ? " dark" : "")
				}>
				{ statisticsTable }
			</div>
		);
	}
}

export default IM27;